import { useContext, useEffect, useState } from 'react';
import { ProjectProgressionFiltersContext } from '../../../../state/filters/contexts';
import ProjectProgressionContext from '../../state/context';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import { getInsights } from 'common/services/project-progression.service';
import { useDebounceCallback } from '@react-hook/debounce';
import useComponentLoading from '../../state/useComponentLoading';
import { PROJECT_PROGRESSION_COMPONENTS } from '../../state/components';
import { clearSelectedInsight } from '../../state/actions';

const useInsightsValues = () => {
  const {
    state: { isInitialized, period, filtersPayload, extraPayload }
  } = useContext(ProjectProgressionFiltersContext);
  const { dispatch } = useContext(ProjectProgressionContext);

  const pmSensorAuthId = usePmSensorAuthId();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useComponentLoading(
    PROJECT_PROGRESSION_COMPONENTS.INSIGHTS
  );

  const fetchInsights = useDebounceCallback(async () => {
    try {
      const res = await getInsights({
        sensor_authorization_id: pmSensorAuthId,
        before: period.before,
        after: period.after,
        filtersPayload,
        ...extraPayload
      });
      setData(res?.data || {});
    } catch (e) {
      setData({});
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    if (!isInitialized) return;
    setIsLoading(true);
    fetchInsights();
  }, [isInitialized, period.before, period.after, filtersPayload]);

  useEffect(() => {
    dispatch(clearSelectedInsight());
  }, [filtersPayload]);

  return {
    isLoading,
    data
  };
};

export default useInsightsValues;
